import React from "react";
import { IonAlert } from "@ionic/react";

export function alertMessage(title: string, message: string, onConfirmed = () => {}, onRejected = () => {}) {
    DialogController.add({header: title, message: message, buttons: [{text: 'Annullér', handler: onRejected}, {text: 'OK', handler: onConfirmed }]});
}


export function alertConfirm(title: string, message: string, onConfirmed = () => {}, onRejected = () => {}) {
    DialogController.add({header: title, message: message, buttons: [{text: 'Nej', handler: onRejected}, {text: 'Ja', handler: onConfirmed }]});
}

export function alertDelete(title: string, message: string, onConfirmed = () => {}, onRejected = () => {}) {
    DialogController.add({header: title, message: message, buttons: [{text: 'Nej', handler: onRejected}, 
        {
            text: 'Ja', 
            handler: onConfirmed,
            cssClass: "red-text"
         }
]});
}

export function alertError(title: string, message: string, onConfirmed = () => {}) {
    DialogController.add({header: title, message: message, buttons: [{text: 'OK', handler: onConfirmed }]});
}

export function alertInput(title: string, message: string, onConfirmed: any, defaultValue = "", placeholder = "") {

    DialogController.add({
        header: title, 
        message: message, 
        value: defaultValue, 
        buttons: ['Cancel', {text: 'OK', handler: onConfirmed }],
        inputs: [
            {
                name: "value",
                type: "text",
                placeholer: placeholder,
            }
        ],
    });
}

export default class DialogController extends React.Component<any, any> {

    public static instance: DialogController; 

    public static add(options: any) {
        this.instance.pushDialog(options);
    }

    private static idCounter: number = 0;

    constructor(props: any) {
        super(props);
        this.state = {
            alerts: []
        }
        DialogController.instance = this;
    }

    pushDialog = (options: any) => {
        options.show = true;
        options.id = DialogController.idCounter++;
        let alerts = this.state.alerts;
        alerts.push(options);
        this.setState({alerts: alerts});
    }

    render() {
        return (
            <div style={{position: "absolute", zIndex: 333333}}>
                {this.state.alerts.map((al: any, index: number) => (
                    <IonAlert key={al.id} isOpen={al.show} onDidDismiss={() => {
                        let alerts = this.state.alerts;
                        let alertIndex = alerts.findIndex((a: any) => a.id === al.id);
                        alerts.splice(alertIndex, 1);
                        this.setState({alerts: alerts});
                    }} {...al}></IonAlert>
                ))}
            </div>
        )
    }
}